import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ActionIcon, Flex, Text } from "@mantine/core";
import {
  IconPencil,
  IconHome,
  IconBan,
  IconDeviceFloppy,
  IconArrowBack,
  IconSearch,
  IconPin,
  IconPinFilled,
} from "@tabler/icons-react";
import axios from "axios";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export default function Header({
  blocked,
  name,
  nickname = "",
  phoneNumber,
  title,
  onUpdate,
  onSearchToggle,
  onBlockedToggle,
  onPinnedToggle,
  pinned,
  userLocationId,
  userOrgId,
}) {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setUsername(nickname);
  }, [nickname]);

  useEffect(() => {
    setOpen(false);
    setLoading(false);
  }, [title]);

  useEffect(() => {
    if (isOpen) {
      const el = document.getElementById("usernameEdit");
      if (el) {
        el.focus();
      }
    }
  }, [isOpen]);

  function onSaveClick() {
    const req = {
      user_location_id: userLocationId,
      user_organization_id: userOrgId,
      nickname: username,
    };

    setLoading(true);

    axios
      .post(`/add-contact-nickname/`, req)
      .then(() => {
        setOpen(false);
        setLoading(false);
        onUpdate();
      })
      .catch((err) => {
        setLoading(false);
      });
  }

  function onPinClick() {
    const req = {
      user_location_id: userLocationId,
      user_organization_id: userOrgId,
    };

    axios
      .post(`/toggle-pinned-conversation/`, req)
      .then(() => {
        toast.success(pinned ? t("user_app:unpinned") : t("user_app:pinned"));
        onUpdate();
        onPinnedToggle();
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  function onBlockClick() {
    const req = {
      user_location_id: userLocationId,
      user_organization_id: userOrgId,
    };

    axios
      .post(`/member-toggle-block/`, req)
      .then(() => {
        toast.success(
          blocked ? t("user_app:unblocked") : t("user_app:blocked")
        );
        onUpdate();
        onBlockedToggle();
      })
      .catch((err) => {
        toast.error(err);
      });
  }

  return (
    <Flex align="center">
      <Flex
        align="center"
        style={{
          flexGrow: 1,
        }}
        gap="sm"
      >
        {!isOpen && (
          <React.Fragment>
            <Text size="xl" fw={600}>
              {nickname || name || phoneNumber}
            </Text>
            {(nickname || name) && <Text c="dimmed">{phoneNumber}</Text>}
            <ActionIcon
              variant="subtle"
              onClick={() => setOpen(true)}
              title={t("user_app:edit_nickname")}
            >
              <IconPencil />
            </ActionIcon>
            <ActionIcon
              variant="subtle"
              onClick={onSearchToggle}
              title={t("common:search")}
            >
              <IconSearch />
            </ActionIcon>
            <ActionIcon
              onClick={onPinClick}
              title={t("user_app:pin")}
              variant="subtle"
            >
              {!pinned ? <IconPin /> : <IconPinFilled />}
            </ActionIcon>
            <ActionIcon
              onClick={onBlockClick}
              title={t("user_app:block")}
              variant="subtle"
            >
              {!blocked ? (
                <IconBan
                  style={{
                    opacity: 0.1,
                  }}
                />
              ) : (
                <IconBan />
              )}
            </ActionIcon>
          </React.Fragment>
        )}
        {isOpen && (
          <Flex align="center">
            <StyledInput
              type="text"
              value={username}
              placeholder={t("user_app:nickname_placeholder")}
              onChange={(e) => setUsername(e.target.value)}
              id="usernameEdit"
              disabled={loading}
            />
            <Flex gap="xs">
              <ActionIcon
                onClick={onSaveClick}
                title={t("common:save")}
                disabled={loading}
                loading={loading}
                variant="subtle"
              >
                <IconDeviceFloppy />
              </ActionIcon>
              <ActionIcon
                onClick={() => setOpen(false)}
                disabled={loading}
                title={t("common:cancel")}
                variant="subtle"
              >
                <IconArrowBack />
              </ActionIcon>
            </Flex>
          </Flex>
        )}
      </Flex>
      {/* <Flex align="center">
        <ActionIcon component={Link} to="/messaging" variant="subtle">
          <IconHome title="Home" />
        </ActionIcon>
      </Flex> */}
    </Flex>
  );
}

const StyledInput = styled.input`
  padding: 8px;
  font-size: 1.15em;
  border-radius: 5px;
  /* border: 2px solid #000; */
  border: none;
  color: var(--textThirdColor);
  background: var(--inputBackground);
  width: 250px;
  margin-right: 8px;
  font-family: inherit;

  &:focus {
    outline: none;
  }
`;
